import { Stack } from '@pairy/pds-react';
import styled from '@emotion/styled';

export const FlexBottomWrapper = styled(Stack)`
  position: absolute;
  bottom: 108px;

  /* 전폭 스트립이 슬라이드 클릭을 가로채지 않도록 버튼에만 이벤트를 허용한다 */
  pointer-events: none;
`;
